const isChunkLoadError = (error: Error): boolean => {
	const message = error?.message || '';
	return (
		message.includes('Failed to fetch dynamically imported module') ||
		message.includes('Loading chunk') ||
		message.includes('ChunkLoadError') ||
		message.includes('is not a valid JavaScript MIME type') ||
		message.includes('Load failed') ||
		error.name === 'ChunkLoadError'
	);
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const retry = (fn: any, retriesLeft = 5, interval = 1000): Promise<any> => {
	return new Promise((resolve, reject) => {
		fn()
			.then(resolve)
			.catch((error: any) => {
				if (isChunkLoadError(error) && retriesLeft === 1) {
					// Check if we've already tried reloading recently to prevent infinite loop
					const lastReloadTime = sessionStorage.getItem('chunk_load_failed');
					const now = Date.now();
					// Consider reload flag stale after 10 seconds (enough for page load cycle)
					const isRecentReload = lastReloadTime && now - parseInt(lastReloadTime, 10) < 10000;

					if (isRecentReload) {
						// Already reloaded recently, let error boundary handle it
						sessionStorage.removeItem('chunk_load_failed');
						reject(error);
						return;
					}
					// Chunk file doesn't exist (likely due to new deployment)
					// Store timestamp and reload to get fresh assets
					sessionStorage.setItem('chunk_load_failed', now.toString());
					window.location.reload();
					return;
				}

				setTimeout(() => {
					if (retriesLeft === 1) {
						reject(error);
						return;
					}
					// Passing on "reject" is the important part
					retry(fn, retriesLeft - 1, interval).then(resolve, reject);
				}, interval);
			});
	});
};
